import {getQueryParam} from './utils';
import {urls} from '../config';

export function isBusinessApplication(app) {
  return app.hasDashboard && !hasEditor(app);
}

export function isEditorApplication(app) {
  return !app.hasDashboard && hasEditor(app);
}

export function isHybridApplication(app) {
  return app.hasDashboard && hasEditor(app);
}

export function hasEditor(app) {
  return !!(app.isWixComponent || app.appType === 'list' || app.hasSection || (app.widgets && app.widgets.length));
}

export function hasPageWidget(app) {
  const widgets = app.widgets || [];

  if (app.appType === 'list') {
    return true;
  }

  for (let i = 0; i < widgets.length; i++) {
    if (widgets[i].type === 'page' && widgets[i].appPage && !widgets[i].appPage.hidden) {
      return true;
    }
  }
  return false;
}

export function madeByWix(app) {
  return app.isWixLabs === true || app.isWixComponent === true;
}

export function alwaysOnDashboard(app) {
  return app.alwaysOnDashboard || app.overrideDashboardUrl;
}

export function isAppNew(app) {
  const daysPublished = (new Date() - new Date(app.publishedAt * 1000)) / 1000 / 3600 / 24;
  return daysPublished <= 30;
}

/**
 * Show secondary button open app. When main is add again.
 */
export function isOpenInEditorVisible(app) {
  return app.isInstalled && hasEditor(app) && !hasPageWidget(app) && !hasAddOnlyOnceWidget(app);
}

export function hasAddOnlyOnceWidget(app) {
  const widgets = app.widgets || [];
  for (let i = 0, len = widgets.length; i < len; i++) {
    if ((widgets[i].default || widgets[i].essential) && widgets[i].addOnlyOnce) {
      return true;
    }
  }
  return false;
}

export function isPublished(app, widget) {
  return (widget && widget.published) || getQueryParam('appDefinitionId') === app.appDefinitionId;
}

export function getDefaultWidget(app) {
  const widgets = app.widgets || [];
  for (let i = 0, len = widgets.length; i < len; i++) {
    if (widgets[i].default && isPublished(app, widgets[i])) {
      return widgets[i];
    }
  }
  return widgets[0];
}

export function isDemoApp() {
  return getQueryParam('demoMode') === 'true';
}

export function shouldOpenEditorApp(app) {
  return app.isInstalled && hasEditor(app) && (hasPageWidget(app) || hasAddOnlyOnceWidget(app));
}

export function alreadyAddedBusinessApp(app) {
  return app.isInstalled || app.alwaysOnDashboard || (app.overrideDashboardUrl && app.appType !== 'list');
}

export function alreadyPendingInMarket(app) {
  return !!app.pendingInMarket;
}

export function getEditorAddAppButtonTitle(app) {
  if (isBusinessApplication(app)) {
    if (alreadyAddedBusinessApp(app)) {
      return 'application.action.open';
    } else if (alreadyPendingInMarket(app)) {
      return 'application.action.launch';
    } else {
      return 'application.action.addToSite';
    }

  } else if (shouldOpenEditorApp(app)) { // page OR addOnlyOnce
    return 'application.action.open';

  } else if (app.isInstalled) { // Widget
    return 'application.action.addAgain';

  } else {
    return 'editor.application.action.addToSite';
  }
}


export function getSignInPageUrl(postLogin, fullUrl) {
  const originUrl = encodeURIComponent(fullUrl);
  const postLoginUrl = encodeURIComponent(postLogin);
  return `${urls.signIn}?originUrl=${originUrl}&postLogin=${postLoginUrl}&postSignUp=${postLoginUrl}`;
}

export function getSiteSelectorEditorAppUrl(appDefinitionId, title, button) {
  const actionUrl = encodeURIComponent(urls.editorEdit + '{{applications.HtmlWeb.idInApp}}?metaSiteId={{metaSiteId}}&editorSessionId={{esi}}&openpanel=market:appDefId:' + appDefinitionId);
  return `${urls.siteSelector}?title=${encodeURIComponent(title)}&buttonText=${encodeURIComponent(button)}&actionUrl=${actionUrl}`;
}

export function getSiteSelectorBusinessAppUrl(appDefinitionId, title, button, config) {
  const selfRedirectUrl = config.fullUrl + '/add-business-app-redirect';
  const actionUrl = encodeURIComponent(selfRedirectUrl + '?metaSiteId={{metaSiteId}}&appDefinitionId=' + appDefinitionId);

  return `${urls.siteSelector}?title=${encodeURIComponent(title)}&buttonText=${encodeURIComponent(button)}&actionUrl=${actionUrl}`;
}



// WEBPACK FOOTER //
// ./services/app-type-detector.js